<div class="max-h-[50vh] overflow-x-hidden overflow-y-auto mt-4">
    <ng-content></ng-content>
</div>
